module.exports = __webpack_public_path__ + "img/4_27.22a0db0a.png";